const API_URL = process.env.REACT_APP_API_URL;

const base = (envId) => `${API_URL}/api/environments/${envId}/flow-assets`;

async function failure(response, fallback) {
  const body = await response.json().catch(() => null);
  return new Error(body?.detail || body?.message || fallback);
}

const flowAssetService = {
  /**
   * Upload an image the assistant may then use.
   *
   * The description is the only thing a generating model ever sees about a picture, so a blank
   * one makes the image effectively invisible: it cannot choose what it cannot read. The
   * filename is a poor description but a far better one than nothing.
   */
  async upload(envId, file, description, authenticatedFetch) {
    const form = new FormData();
    form.append('file', file);
    form.append('description', description || file.name.replace(/\.[^.]+$/, ''));

    // No Content-Type header: the browser has to set the multipart boundary itself.
    const response = await authenticatedFetch(base(envId), { method: 'POST', body: form });
    if (!response.ok) {
      throw await failure(response, `${file.name} could not be uploaded.`);
    }
    return response.json();
  },

  async list(envId, authenticatedFetch) {
    const response = await authenticatedFetch(base(envId));
    if (!response.ok) {
      throw await failure(response, 'Your images could not be loaded.');
    }
    return response.json();
  },

  async remove(envId, assetId, authenticatedFetch) {
    const response = await authenticatedFetch(`${base(envId)}/${assetId}`, { method: 'DELETE' });
    if (!response.ok) {
      throw await failure(response, 'That image could not be removed.');
    }
  },

  contentUrl(envId, assetId) {
    return `${base(envId)}/${assetId}/content`;
  },
};

export default flowAssetService;
